import api from "./client";

export interface DashboardStats {
  total_projects: number;
  projects_not_started: number;
  projects_in_progress: number;
  projects_delivered: number;
  projects_sav: number;
  total_partners: number;
  active_broadcasts: number;
  partners_missing_decennale: number;
  // True when the counts only cover the current user's assigned projects
  // (non-admin without can_view_all_projects). Used by the home screen to
  // relabel the cards and hide admin-only stats.
  scoped_to_current_user: boolean;
}

export const dashboardApi = {
  getStats: async (orgId: string): Promise<DashboardStats> => {
    const { data } = await api.get("/dashboard/stats", {
      params: { org_id: orgId },
    });
    return data;
  },
};
